<template lang="pug">
  .component-tabbed-vehicle-attributes
    ActionBar
      h2(slot="title") Vehicle Attributes
      .fa.fa-plus(slot="action", @click="add = !add")
    .attributes-list(v-show="add")
      .row
        .columns
          .input-group
            selectize-vehicle-attribute.input-group-field(@optionSelected="updateAttributes")
            .input-group-button
              button.button.fa.fa-plus(@click="addAttribute")
      loading-spinner(v-if="addInProgress")
    .container
      .prop-item(v-for="(attribute, index) in attributes")
        .input-group
          span.input-group-label
            MdiIcon(v-if="attribute.attribute.icon" :name="attribute.attribute.icon", :show-name="false")
            span {{attribute.attribute.name}}
          input.input-group-field(type='text', v-model="attribute.value")
          .input-group-button
            button.button.default.fa.fa-save(@click="saveAttribute(attribute)")
            button.button.warning.fa.fa-times(@click="removeAttribute(index)")


</template>
<script type="text/babel">
  import KeplerBackofficeSdk from "src/lib/kepler/backoffice"
  import moment from 'moment'
  import BaseList from '../../../pages/backoffice/BaseList'
  import HeaderColumns from '../../structure/ui/HeaderColumns'
  import collect from 'collect.js'
  import ModalReveal from '../../structure/foundation/ModalReveal'
  import CreateNote from "../../../pages/backoffice/CreateNote";
  import CreateNoteModal from "../../../pages/backoffice/CreateNoteModal";
  import ActionBar from "../../structure/ui/ActionBar";
  import SelectizeInstructions from "../../structure/ui/lists/selectize/SelectizeInstructions";
  import LoadingAnimation from "../../lib/LoadingAnimation";
  import LoadingSpinner from "../../structure/LoadingSpinner";
  import MaggieHelper from "../../../maggieHelper";
  import ArrayEdit from "../../structure/ui/ArrayEdit";
  import SelectizeVehicleAttributesArrayEdit from "../../structure/ui/SelectizeVehicleAttributesArrayEdit";
  import SelectizeVehicleAttribute from "../../structure/ui/lists/selectize/SelectizeVehicleAttribute";
  import MdiIcon from "../../structure/ui/MdiIcon.vue";

  export default {
    name: "TabbedVehicleAttributes",
    components: {
      MdiIcon,
      SelectizeVehicleAttribute,
      SelectizeVehicleAttributesArrayEdit,
      ArrayEdit,
      LoadingSpinner,
      LoadingAnimation,
      SelectizeInstructions,
      ActionBar,
      CreateNoteModal,
      CreateNote,
      ModalReveal,
      HeaderColumns,
      BaseList,
    },
    data() {
      return {
        add: false,
        addInProgress: false,
        instruction_id: null,
        component: require('src/components/backoffice/VehicleAttribute'),
        attributes: [],

        tempAttribute: null,
      }
    },
    created() {
      KeplerBackofficeSdk.vehicles.select(this.$route.params.id, null).attributes((data) => {
        this.attributes = data
      })
    },
    methods: {
      addAttribute() {


        this.attributes.push({
          attribute_id: this.tempAttribute.id,
          attribute: {
            name: this.tempAttribute.name,
          },
          vehicle_attribute_id: null,
          value: null,
        })

        this.tempAttribute = null
      },
      updateAttributes(obj) {
        this.tempAttribute = obj
      },
      saveAttribute(attribute) {


        if (attribute.attribute.id) {

          KeplerBackofficeSdk.vehicleVehicleAttributes.select(attribute.id).edit({
            vehicle_id: this.$route.params.id,
            vehicle_attribute_id: attribute.attribute.id,
            value: attribute.value,
          }, () => {
            MaggieHelper.notification('Updated', 'Attribute updated')
          })
          return
        }

        KeplerBackofficeSdk.vehicleVehicleAttributes.make({
          vehicle_id: this.$route.params.id,
          vehicle_attribute_id: attribute.attribute_id,
          value: attribute.value,
        }, (data) => {
          MaggieHelper.notification('Saved', 'Attribute saved')
        })
      },
      removeAttribute(index) {


        this.$confirm('Are you sure?', 'Do you want to delete this attribute?', () => {
          if (this.attributes[index].id) {
            KeplerBackofficeSdk.vehicleVehicleAttributes.select(this.attributes[index]).remove((data) => {
              MaggieHelper.notification('Deleted', 'Attribute deleted')
            })
          }

          this.attributes.splice(index, 1)
        })
      }
    },
    computed: {},
    props: ['item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-tabbed-vehicle-attributes
    width: 100%
    background: white
    padding-bottom: 25px
    .container
      margin: 20px
    .attributes-list
      padding: 20px

    .input-group-button
      .default
        border-radius: 0
</style>



// WEBPACK FOOTER //
// VehicleAttributes.vue?7b2bf3b0